import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Cool thing thursday: in-browser 3D modeling with live preview ",
  "description": "",
  "published": "2012-09-20T00:00:00.000Z",
  "redirect_from": ["/blog/cool-thing-thursday-in-browser-3d-modeling-with-live-preview/swizec/5296"],
  "categories": "3D modeling, Editors, JavaScript, Source code editor, Three.js, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Last night I went to the first ever github drinkup in Ljubljana. Very fun, but I was left with a lot of thinking time today.`}</p>
    <p>{`After a lot of wandering my thoughts ended up on the `}<em parentName="p"><a parentName="em" {...{
          "href": "http://www.zemanta.com/blog/world-wide-wasteland/"
        }}>{`World Wide Wasteland`}</a></em>{` article I wrote for Zemanta a few weeks ago. A realization hit me - I suck at linking! Sure I try my best to cite sources, but there isn't nearly enough walking up to people and pointing them in an interesting direction.`}</p>
    <p>{`So I'm going to start posting one cool thing every week.`}</p>
    <p>{`That said, here's a cool thing I discovered some time ago: `}<a parentName="p" {...{
        "href": "http://mrdoob.com/projects/code-editor/"
      }}>{`http://mrdoob.com/projects/code-editor/`}</a></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/09/Screen-Shot-2012-09-20-at-4.13.10-PM-1024x695.png",
        "alt": "Mr Doob's code editor",
        "title": "Mr Doob's code editor"
      }}></img></p>
    <p>{`Essentially, it's a code editor complete with syntax highlighting, but it also executes everything you type up and renders it right on top of the editor itself. This allows you to play around with the parameters for those three.js functions and immediately see what happens to the 3D model.`}</p>
    <p>{`Yeah, I know other live editor thingies exist for javascript+html, but so far this is the only one that doesn't eat up all my CPU and become useless after more than 20 lines of code.`}</p>
    <p>{`And I love that in an editor.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://japhr.blogspot.com/2012/09/copying-mr-doobs-code-editor-for-fun.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/110741877_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://japhr.blogspot.com/2012/09/copying-mr-doobs-code-editor-for-fun.html"
        }}>{`Copying Mr Doob's Code Editor for Fun and Phyics`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.elijahmanor.com/2012/09/custom-jsbin-code-editor-settings.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/111138707_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.elijahmanor.com/2012/09/custom-jsbin-code-editor-settings.html"
        }}>{`Custom JSBin Code Editor Settings`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://japhr.blogspot.com/2012/09/converting-from-box2d-to-physijs.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/110741878_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://japhr.blogspot.com/2012/09/converting-from-box2d-to-physijs.html"
        }}>{`Converting from Box2d to Physijs`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://hackaday.com/2012/09/19/turning-video-game-sprites-into-3d-objects/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_41_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://hackaday.com/2012/09/19/turning-video-game-sprites-into-3d-objects/"
        }}>{`Turning video game sprites into 3D objects`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://japhr.blogspot.com/2012/09/threejs-code-clean-up.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/112750800_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://japhr.blogspot.com/2012/09/threejs-code-clean-up.html"
        }}>{`Three.js Code Clean-Up`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=d3a85d38-3421-403f-b4aa-35bc473aae30",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      